import { render } from "./next.svg?vue&type=template&id=6f6b6b4c"
const script = {}
script.render = render

export default script